import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { Subscription } from 'rxjs';
import { Samples } from './../../../../../module/samples/samples';
import { IProductViewSamplesModalProduct } from './../product-view-samples-modal.component';
@Component({
    selector: 'product-view-samples-modal-item',
    templateUrl: './product-view-samples-modal-item.html',
    styleUrls: ['./product-view-samples-modal-item.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ImageModule]
})
export class ProductViewSamplesModalItemComponent implements OnDestroy, OnInit {
    @Input()
    item?: IProductViewSamplesModalProduct;
    subscriptions = new Subscription();
    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private samples: Samples
    ) {}
    ngOnInit(): void {
        this.subscriptions.add(this.samples.updateSubject.subscribe(() => this.detectChanges()));
    }
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
    get sampleId(): number | undefined {
        return this.item?.sampleProduct?.id;
    }
    toggle(): void {
        if (this.item?.product) {
            this.sampleId && this.samples.toggleSample(this.item.product, this.sampleId);
        }
    }
    get selected(): boolean {
        if (this.item?.product) {
            return !!this.sampleId && this.samples.isSampleAdded(this.sampleId);
        }
        return false;
    }
    private detectChanges(): void {
        this.changeDetectorRef.detectChanges();
    }
}
